import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AccountInfo = ({ label, icon, children }) => (
    <div className="mb-4">
        <h6 className="op-7">
            {icon && (
                <>
                    <FontAwesomeIcon icon={icon} />
                    &emsp;
                </>
            )}
            {label}
        </h6>
        {children}
    </div>
);

export default AccountInfo;
